import {
    ODataFilter,
    ODataPageInfo,
    ODataSearch,
    ODataSort
} from './odata.models';

/**
 * Helper class to build out OData strings
 */
export class ODataQueryBuilder {
    /**
     * Builds an OData query string based on the provided search object
     */
    public static buildODataQuery(oDataSearch: ODataSearch): string {
        return `${this.buildODataFilters(
            oDataSearch.filters
        )}&${this.buildODataPageInfo(
            oDataSearch.pageInfo
        )}${this.buildODataSort(oDataSearch.sort)}`;
    }

    /**
     * Builds pagination info string based on the pagination object
     *
     * @param pageInfo The pagination object
     * @returns the pagination string
     */
    public static buildODataPageInfo(pageInfo: ODataPageInfo): string {
        // Prevent page from being less than 1
        if (pageInfo.currentPage < 1) {
            pageInfo.currentPage = 1;
        }
        // we start pages at 1 but skip should start at index 0
        const skip = (pageInfo.currentPage - 1) * pageInfo.resultsPerPage;
        return `$skip=${skip}&$top=${pageInfo.resultsPerPage}&`;
    }

    /**
     * Builds a sort string based on the provided sort object
     *
     * @param oDataSort The sort object
     * @returns The built sort string or empty if the object is falsy
     */
    public static buildODataSort(oDataSort: ODataSort): string {
        if (!oDataSort?.sortField) {
            return '';
        }
        return `$orderby=${
            oDataSort.sortField
        } ${oDataSort.sortDirection.toString()}`;
    }

    /**
     * Builds the OData filter string based on the provided filters
     *
     * @param oDataFilters the ODataFilters object
     * @returns the filter string
     */
    public static buildODataFilters(oDataFilters: ODataFilter[]): string {
        return oDataFilters
            .map((pair) => `$${pair.key}=${this.encodeFilterValue(pair.value)}`)
            .join('&');
    }

    /**
     * Encodes the value and encapsulates the value in quotes.  This is so that the backend does not throw an exception
     * when numbers are included in the query.
     *
     * @param value the value to be encoded
     * @returns the quoted encoded value
     */
    private static encodeFilterValue(value: string): string {
        return encodeURIComponent(`"${value}"`);
    }
}
